:host {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  cursor: pointer;

  .lgr-phone-number-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: var(--lgr-spacing-xs);
    max-height: var(--lgr-spacing-xs);
    min-width: var(--lgr-spacing-xs);
    max-width: var(--lgr-spacing-xs);
    font-size: var(--lgr-font-size-xl);
    padding: var(--lgr-spacing-nano);
    border-radius: 50%;
    color: var(--lgr-color-neutral-high-pure);
    background-color: var(--lgr-color-neutral-low-pure);
  }

  .lgr-phone-number-text {
    padding: var(--lgr-spacing-quarck) var(--lgr-spacing-nano);
  }

  .lgr-phone-number-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #F4F4F4 53.02%, rgba(244, 244, 244, 0.00) 82.05%);

    &-visible {
      display: none;
    }
  }
}